'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { POPOVER_TRANSITION_TIMING } from 'HubStyleTokens/times';
import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import UIMedia from '../layout/UIMedia';
import UIMediaBody from '../layout/UIMediaBody';
import UIMediaRight from '../layout/UIMediaRight';
import UITruncateString from '../text/UITruncateString';
import UITableHoverContent from './UITableHoverContent';
const POPOVER_TRANSITION_DELAY = parseInt(POPOVER_TRANSITION_TIMING, 10);
const StyledMedia = styled(UIMedia).withConfig({
  displayName: "UITableHoverCell__StyledMedia",
  componentId: "kjs4sh-0"
})(["height:100%;"]);
export default class UITableHoverCell extends Component {
  constructor(props) {
    super(props);

    this.handleHoverContentOpenChange = evt => {
      const rowIsHovered = evt.target.value;

      if (!rowIsHovered !== this.state.hoverContentIsClosing) {
        // Remove hover content's left margin while closing (#2412)
        this.setState({
          hoverContentIsClosing: !rowIsHovered
        });
      }

      this.setState({
        rowIsHovered
      });

      if (rowIsHovered) {
        clearTimeout(this._hideTimeout);
        this.setState({
          hoverContentIsClosed: false
        });
      } else {
        this._hideTimeout = setTimeout(() => {
          this.setState({
            hoverContentIsClosed: true
          });
        }, POPOVER_TRANSITION_DELAY);
      }
    };

    this.handleTooltipOpenChange = evt => {
      this.setState({
        tooltipIsOpen: !!evt.target.value
      });
    };

    const {
      hoverContentProps
    } = props;

    const _rowIsHovered = hoverContentProps ? !!hoverContentProps.open : false;

    this.state = {
      rowIsHovered: _rowIsHovered,
      hoverContentIsClosed: !_rowIsHovered,
      hoverContentIsClosing: false,
      tooltipIsOpen: false
    };
  }

  componentWillUnmount() {
    clearTimeout(this._hideTimeout);
  }

  render() {
    const _this = this,
          {
      props: {
        children,
        hoverContent,
        hoverContentProps,
        tooltip,
        truncateStringProps
      },
      state: {
        hoverContentIsClosed,
        hoverContentIsClosing,
        rowIsHovered,
        tooltipIsOpen
      }
    } = _this,
          rest = _objectWithoutPropertiesLoose(_this.props, ["children", "hoverContent", "hoverContentProps", "tooltip", "truncateStringProps"]);

    const open = hoverContentProps && hoverContentProps.open || rowIsHovered || tooltipIsOpen;
    return /*#__PURE__*/_jsx("td", Object.assign({}, rest, {
      children: /*#__PURE__*/_jsxs(StyledMedia, {
        align: "center",
        children: [/*#__PURE__*/_jsx(UIMediaBody, {
          children: /*#__PURE__*/_jsx(UITruncateString, Object.assign({
            open: tooltipIsOpen
          }, truncateStringProps, {
            "data-content-hovered": rowIsHovered,
            tooltip: tooltip,
            onOpenChange: this.handleTooltipOpenChange,
            children: children
          }))
        }), hoverContent && /*#__PURE__*/_jsx(UIMediaRight, {
          className: classNames(!open && [hoverContentIsClosing && 'm-left-0', hoverContentIsClosed && 'sr-only']),
          children: /*#__PURE__*/_jsx(UITableHoverContent, Object.assign({
            open: open,
            onOpenChange: this.handleHoverContentOpenChange,
            shrinkOnHide: true
          }, hoverContentProps, {
            children: hoverContent
          }))
        })]
      })
    }));
  }

}
UITableHoverCell.propTypes = {
  children: PropTypes.node.isRequired,
  hoverContent: PropTypes.node,
  tooltip: PropTypes.oneOfType([PropTypes.bool, PropTypes.node, PropTypes.string]).isRequired,
  hoverContentProps: PropTypes.object,
  truncateStringProps: PropTypes.object
};
UITableHoverCell.defaultProps = {
  tooltip: true
};
UITableHoverCell.displayName = 'UITableHoverCell';